import { FeatureFlag } from '@ps/web-core-enums';
import { useFeature } from '@ps/web-core-store';
import { useMemo } from 'react';

import CasinoBonusCard from '../components/Featured/components/CasinoBonusCard/CasinoBonusCard';
import PowerPathCard from '../components/Featured/components/PowerPathCard/PowerPathCard';

interface FeaturedNavItem {
  Component: () => JSX.Element;
  visible: boolean;
}

const useFeaturedNavItems = (): FeaturedNavItem[] => {
  const powerPathEnabled = useFeature(FeatureFlag.PowerPathTile);
  const casinoSOTDEnabled = useFeature(FeatureFlag.CasinoSpinOfDay);
  const prhubSOTDEnabled = useFeature(FeatureFlag.SpinOfTheDayTile);

  const featuredNavItems = useMemo(
    () => [
      {
        Component: () => <PowerPathCard />,
        visible: powerPathEnabled
      },
      {
        Component: () => <CasinoBonusCard variant="StandardSotd" />,
        visible: casinoSOTDEnabled && prhubSOTDEnabled
      },
      {
        Component: () => <CasinoBonusCard variant="BonusRounds" />,
        visible: casinoSOTDEnabled && prhubSOTDEnabled
      }
    ],
    [powerPathEnabled, casinoSOTDEnabled, prhubSOTDEnabled]
  );

  return featuredNavItems.filter(({ visible }) => !!visible);
};

export default useFeaturedNavItems;
